import axios from 'axios'
import router from '../router'
const request = axios.create({
  baseURL: '/api',
  timeout: 60000, // AI请求可能需要更长时间
  withCredentials: true
})

// 全局响应拦截：未登录时强制跳转登录页
request.interceptors.response.use(
  (response) => {
    const data = response && response.data;
    const url = (response && response.config && response.config.url) || '';
    // 登录/注册接口不做未登录跳转处理
    if (url.includes('/user/login') || url.includes('/user/register')) {
      return response;
    }
    if (data && data.code !== 200) {
      const msg = data.message || '';
      if (msg.includes('未登录') || msg.includes('请先登录')) {
        router.push('/login');
        return Promise.reject(new Error('未登录'));
      }
    }
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

// 发送聊天消息
export const sendMessage = (message) => {
  return request.post('/ai/chat', { message })
}

// 获取聊天历史
export const getChatHistory = (limit = 50) => {
  return request.get('/ai/history', {
    params: { limit }
  })
}

// 清空聊天历史
export const clearChatHistory = () => {
  return request.delete('/ai/history')
}
